/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
// import projectSettings from '../lib/projectSettings';
// import baseConfig from '../../static/baseConfig'; 
// var baseConfig = JSON.parse(projectSettings)
// ZJConfig.current.getValue('api.base_url', ''),
var baseConfig = {
    baseUrl:global.$config.api.apiUrl
    // baseUrl:"https://biaozhunhua.zjht100.com/tsscanalysis"
    // baseUrl:"http://222.128.10.58:9018"
}
import axios from 'axios'; 
// 环境的切换
// console.log('baseUrl::', baseConfig.baseUrl)
if (process.env.NODE_ENV == 'development') {    
    axios.defaults.baseURL = baseConfig.baseUrl;
} else if (process.env.NODE_ENV == 'debug') {    
    axios.defaults.baseURL = baseConfig.baseUrl;
} else if (process.env.NODE_ENV == 'production') {    
    axios.defaults.baseURL = baseConfig.baseUrl;
}
console.log('axiosUrl::', axios.defaults.baseURL)
// 请求超时时间
axios.defaults.timeout = 20000;
 
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json';

/** 
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function get(url, params){    
    return new Promise((resolve, reject) =>{        
        axios.get(url, {
            params:params,
            headers:{"Content-Type":"application/json"}
        })        
        .then(res => {            
            resolve(res.data);        
        })        
        .catch(err => {            
            reject(err.data)        
        })    
    });
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
   //platform为3表示pc {"platform":3},
 */
export function post(url, params) {  
    axios.defaults.baseURL = baseConfig.baseUrl;
    return new Promise((resolve, reject) => {         
        axios.post(url,params)          
        .then(res => {            
            resolve(res.data);        
        })        
        .catch(err => {            
            reject(err.data)        
        })    
    });
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
   //platform为3表示pc {"platform":3},
 */
export function axiosPost(url, params) {  
    if (params.baseUrl) {
        axios.defaults.baseURL = params.baseUrl;
    }else{
        axios.defaults.baseURL = baseConfig.baseUrl;
    }
    // console.log("axios.defaults.baseURL")
    // console.log(axios.defaults.baseURL)
    return new Promise((resolve, reject) => {         
        axios.post(url,params.data)          
        .then(res => {            
            resolve(res.data);        
        })        
        .catch(err => {            
            reject(err.data)        
        })    
    });
}

export function axiosPostJson(url,params={}){
    return new Promise((resolve, reject) => {
        axios
          .post(url, params)
          .then(response => {
            resolve(response.data)
          })
          .catch(err => {
            reject(err)
          })
      })
  }

